import React from 'react';

import {useState} from "@wordpress/element";
import {decodeEntities} from '@wordpress/html-entities';
import {__} from '@wordpress/i18n';

import Button from '@woocommerce/base-components/button';
import LoadingMask from '@woocommerce/base-components/loading-mask';
import {VALIDATION_STORE_KEY, CART_STORE_KEY} from '@woocommerce/block-data';
import {ValidatedTextInput, ValidationInputError} from '@woocommerce/blocks-components';
import {useDispatch, useSelect, dispatch} from '@wordpress/data';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";

const RegularVouchers = () => {
    const {displayGiftCardForm, addVoucherToList, isLoading} = useStoreCartVouchers();

    const textInputId = `wc-block-components-totals-coupon__input-0`;

    const [couponCodeFromInput, setCouponCodeFromInput] = useState('');

    const {validationErrorId} = useSelect((select) => {
        const store = select(VALIDATION_STORE_KEY);

        return {
            validationErrorId: store.getValidationErrorId(textInputId),
        };
    });

    const {setValidationErrors} = useDispatch(VALIDATION_STORE_KEY);

    const handleError = (reason) => {
        setValidationErrors({
            coupon: {
                message: decodeEntities(reason.message),
                hidden: false,
            },
        });
    }

    const handleCouponSubmit = (e) => {
        e.preventDefault();

        addVoucherToList(couponCodeFromInput)
            .then(response => {
                if (response.type === 'gift') {
                    return displayGiftCardForm(response.code, response.balance, response.balance_localized);
                } else {
                    return dispatch(CART_STORE_KEY).invalidateResolutionForStore();
                }
            }).catch(reason => {
            handleError(reason);
            return Promise.resolve(false);
        });
    }

    return (
        <LoadingMask
            screenReaderLabel={__(
                'Applying coupon…',
                'woocommerce'
            )}
            isLoading={isLoading}
            showSpinner={false}>
            <form
                className="wc-block-components-totals-coupon__form"
                id="wc-block-components-totals-coupon__form">
                <ValidatedTextInput
                    id={textInputId}
                    errorId="coupon"
                    className="wc-block-components-totals-coupon__input"
                    label={__('Enter code', 'voucherify')}
                    value={couponCodeFromInput}
                    ariaDescribedBy={validationErrorId}
                    onChange={(newCouponCode) => {
                        setCouponCodeFromInput(newCouponCode);
                    }}
                    focusOnMount={true}
                    validateOnMount={false}
                    showError={false}
                />
                <Button
                    className="wc-block-components-totals-coupon__button"
                    disabled={isLoading || !couponCodeFromInput}
                    showSpinner={isLoading}
                    onClick={handleCouponSubmit}
                    type="submit"
                >
                    {__('Apply', 'woocommerce')}
                </Button>
            </form>
            <ValidationInputError
                propertyName="coupon"
                elementId={textInputId}/>
        </LoadingMask>
    );
}

export default RegularVouchers;
